module.exports = __webpack_public_path__ + "static/chacha-04fa4bb72b433c5644ff525a8f4c87f3.mp4";